import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as actionTypes from './constants';

export const data = handleActions(
  {
    [combineActions(
      actionTypes.NOTIFICATION_INFO_REQUEST,
      actionTypes.CALL_INFO_REQUEST,
      actionTypes.NOTIFICATION_INFO_FAILURE,
      actionTypes.CALL_INFO_FAILURE,
    )]: () => ({}),
    [actionTypes.NOTIFICATION_INFO_SUCCESS]: (state, { payload }) => payload.notification,
    [actionTypes.CALL_INFO_SUCCESS]: (state, { payload }) => payload.call,
  },
  {},
);

export const parentInfo = handleActions(
  {
    [combineActions(
      actionTypes.NOTIFICATION_INFO_REQUEST,
      actionTypes.NOTIFICATION_INFO_FAILURE,
    )]: () => ({}),
    [actionTypes.NOTIFICATION_INFO_SUCCESS]: (state, { payload }) => payload.parentInfo,
  },
  {},
);

export const partners = handleActions(
  {
    [combineActions(
      actionTypes.NOTIFICATION_INFO_REQUEST,
      actionTypes.CALL_INFO_REQUEST,
      actionTypes.NOTIFICATION_INFO_FAILURE,
      actionTypes.CALL_INFO_FAILURE,
    )]: () => [],
    [combineActions(actionTypes.NOTIFICATION_INFO_SUCCESS, actionTypes.CALL_INFO_SUCCESS)]: (
      state,
      { payload },
    ) => payload.partners,
  },
  [],
);

export const notes = handleActions(
  {
    [combineActions(
      actionTypes.NOTIFICATION_INFO_REQUEST,
      actionTypes.CALL_INFO_REQUEST,
      actionTypes.NOTIFICATION_INFO_FAILURE,
      actionTypes.CALL_INFO_FAILURE,
    )]: () => [],
    [combineActions(actionTypes.NOTIFICATION_INFO_SUCCESS, actionTypes.CALL_INFO_SUCCESS)]: (
      state,
      { payload },
    ) => payload.notes,
  },
  [],
);

export const taskList = handleActions(
  {
    [combineActions(
      actionTypes.NOTIFICATION_INFO_REQUEST,
      actionTypes.CALL_INFO_REQUEST,
      actionTypes.NOTIFICATION_INFO_FAILURE,
      actionTypes.CALL_INFO_FAILURE,
    )]: () => ({}),
    [combineActions(actionTypes.NOTIFICATION_INFO_SUCCESS, actionTypes.CALL_INFO_SUCCESS)]: (
      state,
      { payload },
    ) => payload.taskList,
  },
  {},
);

export const partList = handleActions(
  {
    [combineActions(
      actionTypes.NOTIFICATION_INFO_REQUEST,
      actionTypes.CALL_INFO_REQUEST,
      actionTypes.NOTIFICATION_INFO_FAILURE,
      actionTypes.CALL_INFO_FAILURE,
    )]: () => ({}),
    [combineActions(actionTypes.NOTIFICATION_INFO_SUCCESS, actionTypes.CALL_INFO_SUCCESS)]: (
      state,
      { payload },
    ) => payload.partList,
  },
  {},
);

export const actions = handleActions(
  {
    [combineActions(
      actionTypes.NOTIFICATION_INFO_REQUEST,
      actionTypes.CALL_INFO_REQUEST,
      actionTypes.NOTIFICATION_INFO_FAILURE,
      actionTypes.CALL_INFO_FAILURE,
    )]: () => [],
    [combineActions(actionTypes.NOTIFICATION_INFO_SUCCESS, actionTypes.CALL_INFO_SUCCESS)]: (
      state,
      { payload },
    ) => payload.actions,
  },
  [],
);

export const isLoading = handleActions(
  {
    [combineActions(actionTypes.NOTIFICATION_INFO_REQUEST, actionTypes.CALL_INFO_REQUEST)]: () =>
      true,
    [combineActions(
      actionTypes.NOTIFICATION_INFO_SUCCESS,
      actionTypes.NOTIFICATION_INFO_FAILURE,
      actionTypes.CALL_INFO_SUCCESS,
      actionTypes.CALL_INFO_FAILURE,
    )]: () => false,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.NOTIFICATION_INFO_REQUEST,
      actionTypes.NOTIFICATION_INFO_SUCCESS,
      actionTypes.CALL_INFO_REQUEST,
      actionTypes.CALL_INFO_SUCCESS,
    )]: () => ({}),
    [combineActions(actionTypes.NOTIFICATION_INFO_FAILURE, actionTypes.CALL_INFO_FAILURE)]: (
      state,
      { payload },
    ) => payload.error,
  },
  {},
);

export default combineReducers({
  data,
  partners,
  notes,
  taskList,
  partList,
  parentInfo,
  actions,
  isLoading,
  error,
});
